import { configureStore } from '@reduxjs/toolkit';
import progressReducer from './progressSlice';
import dataReducer from './dataSlice';

export const store = configureStore({
  reducer: {
    progress: progressReducer,
    data: dataReducer
  },
});